export default __webpack_public_path__ + "static/media/image 73.3c254aca.webp";